<script>
import Helpers from "@/mixins";
export default {
  mixins:[Helpers],
  props:["data",'index'],
  mounted(){
    this.Helpers;
  }
}
</script>
